import type { ConsultationModel } from '@/types';

export const getConsultLoggingInfo = ({
  isDoc,
  canUserChargeConsult,
  patientId,
  isConcessionPatient,
  consult,
  extraProperties
}: {
  isDoc: boolean;
  canUserChargeConsult: boolean;
  patientId: number;
  isConcessionPatient: boolean;
  consult?: ConsultationModel;
  extraProperties?: Record<string, string | number | boolean>;
}) => ({
  isDoc,
  canShowChargeButton: canUserChargeConsult,
  patientId,
  consultationId: consult?.id,
  consultationType: consult?.consult_type,
  consultationCode: consult?.consultation_code,
  statusId: consult?.status_id,
  doctorId: consult?.doctor_id,
  paymentQueued: consult?.payment_queued,
  paymentStatus: consult?.payment_status,
  xeroConsultationCode: consult?.xero_consultation_code,
  calcomConsultationUuid: consult?.calcom_consultation_uuid,
  isConcessionPatient,
  extraProperties
});
